import axios from 'axios';

/** Same-origin when empty (Apache on hosting.fair-corp.com proxies /api/ to faircorp-api). */
const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL ?? '',
  timeout: 15000,
  headers: { 'Content-Type': 'application/json' },
});

export function getHostingVisits() {
  return api.get<{ counts: Record<string, number> }>('/api/hosting/visits');
}

export function incrementHostingVisit(siteKey: string) {
  return api.post<{ siteKey: string; count: number }>('/api/hosting/visits', { siteKey });
}

/** One POST per JS realm. Survives React StrictMode double-mount; resets on hard refresh. */
let documentVisitSent = false;

export function recordHostingDocumentVisit(siteKey: string) {
  if (documentVisitSent) return;
  documentVisitSent = true;
  incrementHostingVisit(siteKey).catch(() => {});
}

export default api;
